import { IPaginationInput } from '@models/payload/customer';
import {
  ActiveTableCategoryPayload,
  ActiveTablePayload,
  CreateTableCategoryPayload,
  CreateTablePayload,
  GetTableParams,
  UpdateOrderTableParams,
  UpdateTableCategoryPayload,
  UpdateTablePayload,
} from '@models/payload/table';
import { NetworkStatus } from '@models/payload/types';
import { offlineRopoloRequest, ropoloRequest } from '@services/axios';
import { FreeTablePayload } from './type';

export const DEFAULT_TABLE_PARAMS: GetTableParams = {
  IsActive: true,
  PageNumber: 1,
  PageSize: 1000,
};

const getTables = async ({ networkStatus, ...param }: GetTableParams & NetworkStatus) =>
  (
    await (networkStatus
      ? ropoloRequest.diningtableTablesList(param)
      : offlineRopoloRequest.diningtableTablesList(param))
  )?.data;

const getTableById = async (id: string) => (await ropoloRequest.diningtableTablesDetail(id))?.data;

const createTable = async (params: CreateTablePayload) => (await ropoloRequest.diningtableCreate(params))?.data;

const updateTable = async (params: UpdateTablePayload) => (await ropoloRequest.diningtableUpdate(params))?.data;

const updateOrderTable = async ({ networkStatus, ...params }: UpdateOrderTableParams & NetworkStatus) =>
  (
    await (networkStatus
      ? ropoloRequest.ordersChangetableUpdate(params)
      : offlineRopoloRequest.ordersChangetableUpdate(params))
  )?.data;

const activeTable = async (params: ActiveTablePayload) =>
  (await ropoloRequest.diningtableTablesPartialUpdate(params))?.data;

const getTableCategories = async (params: IPaginationInput) =>
  (await ropoloRequest.diningtablecategoriesList(params))?.data;

const createTableCategory = async (params: CreateTableCategoryPayload) =>
  (await ropoloRequest.diningtablecategoriesCreate(params))?.data;

const updateTableCategory = async (params: UpdateTableCategoryPayload) =>
  (await ropoloRequest.diningtablecategoriesUpdate(params))?.data;

const activeTableCategory = async (params: ActiveTableCategoryPayload) =>
  (await ropoloRequest.diningtablecategoriesPartialUpdate(params))?.data;

const getTableCategoryById = async (id: string) => (await ropoloRequest.diningtablecategoriesDetail(id))?.data;

const getDiningTablesList = async () => (await ropoloRequest.diningtableReservesList())?.data;

const freeDiningTableRequest = async (params: FreeTablePayload) =>
  (await ropoloRequest.diningtableReservesPartialUpdate(params))?.data;

const freeDiningTables = async () => ropoloRequest.diningtableReservesFreeUpdate();

export {
  activeTable,
  activeTableCategory,
  createTable,
  createTableCategory,
  getTableById,
  getTableCategories,
  getTableCategoryById,
  getTables,
  updateOrderTable,
  updateTable,
  updateTableCategory,
  getDiningTablesList,
  freeDiningTableRequest,
  freeDiningTables,
};
